import { exportToGdocs } from '@/features/tools/api'
import ExportButton from '@/ui/ExportButton'
import logoDrive from '/images/logos/drive.svg'
import { useGDocsExport } from '@/hooks/useGDocsExport'

export const GDocsExportButton = ({
  threadId,
  messageIdx,
}: {
  threadId: string
  messageIdx: number
}) => {
  const { state, handleClick } = useGDocsExport(() =>
    exportToGdocs(threadId, messageIdx),
  )

  return (
    <ExportButton
      isReady={state.status === 'open'}
      isLoading={state.status === 'generating'}
      logo={logoDrive}
      text={
        state.status === 'open'
          ? 'Ver en Google Docs'
          : 'Exportar a Google Docs'
      }
      caption={
        state.status === 'connect-account'
          ? 'Solicitaremos conectar tu cuenta de Google.'
          : undefined
      }
      onClick={handleClick}
    />
  )
}
